/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyRemediationConfigurationStatus {
    getFixupPrototypeFunction() { return PolicyRemediationConfigurationStatus.fixupPrototype; }

    static newInstance(model: Partial<PolicyRemediationConfigurationStatus>): PolicyRemediationConfigurationStatus {
        let obj = Object.assign(new PolicyRemediationConfigurationStatus(), model);
        PolicyRemediationConfigurationStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyRemediationConfigurationStatus>): PolicyRemediationConfigurationStatus {
        if (!model) return null;
        return PolicyRemediationConfigurationStatus.newInstance(<PolicyRemediationConfigurationStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyRemediationConfigurationStatus) {
        if (!obj) return;

        models.PolicyRemediationConfigurationStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyRemediationConfigurationStatus): boolean {
        Object.setPrototypeOf(obj, PolicyRemediationConfigurationStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Whether auto-remediation is enabled for this policy
     */
    status: models.PolicyAutoRemediationStatus;

    /**
     * Name of the remediation action applied automatically when a violation is found.
     */
    remediation_action: string;

}
